<template>
    <div
        :class="{
            'media-counter': true,
            [`media-counter--${size}`]: size,
            [`media-counter--disabled`]: disabled,
            'media-counter--clickable': clickable,
        }"
        @click="onClick"
    >
        <div class="media-counter__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * Media counter badge component
 *
 * @version 4.0.0
 * @example ./../examples/MediaCounter.md
 */
export default {
    name: 'MediaCounter',
    props: {
        /**
         * Whether or not it's clickable
         */
        clickable: {
            type: Boolean,
            default: false,
        },
        /**
         * Size. Available values: `medium`
         */
        size: {
            type: String,
            default: '',
            validator: (value) => ['medium', ''].includes(value),
        },
        /**
         * Whether or not it's disabled
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(...args) {
            if (!this.clickable || this.disabled) {
                return;
            }

            /**
             * Fired when `clickable`, not `disabled` and clicked
             *
             * @event click
             * @type {object}
             */
            this.$emit('click', ...args);
        },
    },
};
</script>

<style lang="scss" src="@v4/common/components/molecules/MediaCounter/_index"></style>
